import React from 'react';
import { Typography, Button, Switch, Divider } from 'antd';
import { PrinterOutlined, DeleteOutlined } from '@ant-design/icons';
import { IoCreateOutline, IoEyeOffOutline, IoLayersOutline, IoOptionsOutline } from "react-icons/io5";

const { Text } = Typography;

const CardProductoMobile = ({ 
    prod, 
    hasPermission, 
    onPrint, 
    onEdit, 
    onDelete, 
    onStatusChange 
}) => {
    // Definir colores de stock
    const stockNum = Number(prod.stock);
    const bgStock = stockNum <= 0 ? '#fef2f2' : (stockNum <= 5 ? '#fefce8' : '#f0fdf4');
    const colorStock = stockNum <= 0 ? '#ef4444' : (stockNum <= 5 ? '#ca8a04' : '#16a34a');

    // Manejo seguro de estados booleanos
    const isActive = prod.status === 'active';
    const isVisibleEnPOS = prod.visible_catalogo !== false && prod.visible_catalogo !== 'false';

    return (
        <div style={{ 
            backgroundColor: '#fff', 
            borderRadius: '12px', 
            border: '1px solid #e2e8f0', 
            marginBottom: '12px', 
            overflow: 'hidden', 
            boxShadow: '0 1px 3px rgba(0,0,0,0.02)' 
        }}>
            {/* --- SECCIÓN SUPERIOR: DATOS --- */}
            <div style={{ padding: '14px 16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px', marginBottom: '8px' }}>
                    
                    {/* Nombre, Etiquetas, Código y Categoría */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', flex: 1, paddingRight: '10px' }}>
                        <Text strong style={{ fontSize: '15px', lineHeight: '1.2', color: '#0f172a' }}>
                            {prod.nombre}
                        </Text>
                        
                        {/* Contenedor de Insignias (Oculto, Combo, Variantes) */}
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                            {!isVisibleEnPOS && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#fffbeb', color: '#d97706', border: '1px solid #fde68a', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '700' }}>
                                    <IoEyeOffOutline size={12} />
                                    Oculto en POS
                                </div>
                            )}
                            
                            {prod.es_combo && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '700' }}>
                                    <IoLayersOutline size={12} />
                                    COMBO
                                </div>
                            )}

                            {prod.has_variants && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '700' }}>
                                    <IoOptionsOutline size={12} />
                                    VARIANTES
                                </div>
                            )}
                        </div>

                        <Text type="secondary" style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
                            {prod.codigoBarras || 'Sin código'} • {prod.categoria || 'Sin cat.'}
                        </Text>
                    </div>
                    
                    {/* Controles de Estado (Activo y POS) */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px', flexShrink: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <Text style={{ fontSize: '9px', fontWeight: '800', color: isActive ? '#10b981' : '#94a3b8', letterSpacing: '0.5px' }}>
                                {isActive ? 'ACTIVO' : 'INACTIVO'}
                            </Text>
                            <Switch 
                                size="small" 
                                checked={isActive} 
                                onChange={(checked) => onStatusChange({ ...prod, status: checked ? 'active' : 'inactive' })} 
                                style={{ backgroundColor: isActive ? '#10b981' : '#cbd5e1' }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <Text style={{ fontSize: '9px', fontWeight: '800', color: isVisibleEnPOS ? '#0ea5e9' : '#d97706', letterSpacing: '0.5px' }}>
                                {isVisibleEnPOS ? 'EN POS' : 'OCULTO'}
                            </Text>
                            <Switch 
                                size="small" 
                                checked={isVisibleEnPOS} 
                                onChange={(checked) => onStatusChange({ ...prod, visible_catalogo: checked })} 
                                style={{ backgroundColor: isVisibleEnPOS ? '#0ea5e9' : '#cbd5e1' }}
                            />
                        </div>
                    </div>
                </div>
                
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginTop: '12px' }}>
                    <Text style={{ fontSize: '16px', fontWeight: '800', color: '#22BABB' }}>
                        {prod.precioVenta}
                    </Text>
                    <div style={{ backgroundColor: bgStock, color: colorStock, padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: '700' }}>
                        Stock: {prod.stock}
                    </div>
                </div>
            </div>

            {/* --- SECCIÓN INFERIOR: BARRA DE ACCIONES HORIZONTAL --- */}
            <div style={{ display: 'flex', borderTop: '1px solid #f1f5f9', background: '#f8fafc' }}>
                <Button 
                    type="text" 
                    icon={<IoCreateOutline size={18} />} 
                    onClick={() => onEdit(prod)} 
                    style={{ flex: 1, height: '40px', borderRadius: 0, color: '#475569', fontWeight: 600 }}
                >
                    Editar
                </Button>
                
                <Divider type="vertical" style={{ height: '40px', margin: 0, borderColor: '#e2e8f0' }} />
                
                <Button 
                    type="text" 
                    icon={<PrinterOutlined size={16} />} 
                    onClick={() => onPrint(prod)} 
                    style={{ flex: 1, height: '40px', borderRadius: 0, color: '#475569', fontWeight: 600 }}
                >
                    Etiqueta
                </Button>
                
                <Divider type="vertical" style={{ height: '40px', margin: 0, borderColor: '#e2e8f0' }} />
                
                <Button 
                    type="text" 
                    disabled={!hasPermission('productos:eliminar')} 
                    icon={<DeleteOutlined size={17} />} 
                    onClick={() => onDelete(prod)} 
                    style={{ width: '50px', height: '40px', borderRadius: 0, color: '#ef4444' }} 
                />
            </div>
        </div>
    );
};

export default CardProductoMobile;